import { StateDropDown } from '@apply/components';
import { useExperienceAddressState } from '../../../../fields/ExperienceFields';
import { isMobileScreen } from '@apply/ui';

interface ExperienceStateProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
    validator?: React.ReactNode;
}

export const ExperienceState: React.FC<ExperienceStateProps> = ({
    experienceId,
    required = false,
    readOnly = false,
    validator,
}) => {
    const mobileScreen = isMobileScreen();
    const label = 'State ';
    const [state, set_state] = useExperienceAddressState(experienceId);

    return (
        <>
            <>
                <StateDropDown
                    id='experienceState'
                    value={state}
                    onChange={(value) => set_state(value)}
                    label={label}
                    required={required}
                    width={mobileScreen ? '100%' : '210px'}
                    readOnly={readOnly}
                    validator={validator}
                />
            </>
        </>
    );
};
